/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
}));

interface DiscountBadgeProps {
  active: boolean;
  activeColor: string;
  inactiveColor: string;
}

export const DiscountBadge = styled(Box, {
  shouldForwardProp: prop =>
    prop !== 'active' && prop !== 'activeColor' && prop !== 'inactiveColor',
})<DiscountBadgeProps>(({theme, active, activeColor, inactiveColor}) => ({
  height: '28px',
  padding: theme.spacing(0, 2),
  borderRadius: '100px',
  background: active ? activeColor : inactiveColor,
  display: 'flex',
  alignItems: 'center',
}));

export const NoteText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));
